import Browse from "@/pages/Browse";

/**
 * FeaturedPage: canonical URL /servers/featured.
 * Renders Browse pre-filtered to featured=true with distinct SEO + no toggle.
 */
export default function FeaturedPage() {
  return <Browse routeFeatured />;
}
